import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API, auth } from '../shared';
import KpiCard from '../KpiCard';
import UnifiedAdvancedReportsSection from '../../../../components/reports/UnifiedAdvancedReportsSection';

// التقارير الرياضية المتقدمة: مقدمة KPI سريعة + المحرك القديم الكامل (بلا تعديل منطقي) للاعبين/الفرق/المباريات/الهدافين/داخل وخارج الأرض
export default function SportsTab({ seasonId, seasons = [], onSeasonChange }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ players: [], teams: [], matches: [], tournaments: [], categories: [], clubInfo: null });
  const [reportSettings, setReportSettings] = useState({
    includeLogo: true,
    includeHeader: true,
    includeFooter: true,
    headerText: 'تقرير المنشأة الرياضية',
    footerText: 'تم إنشاء هذا التقرير تلقائياً',
    dateFormat: 'arabic',
  });

  useEffect(() => {
    (async () => {
      const qs = seasonId && seasonId !== 'all' ? `?season_id=${seasonId}` : '';
      const g = (url) => axios.get(`${API}${url}`, auth()).then((r) => r.data).catch(() => null);
      const [players, teams, matches, tournaments, categories, clubInfo] = await Promise.all([
        g(`/players${qs}`), g(`/teams${qs}`), g(`/matches${qs}`), g('/tournaments'), g(`/categories${qs}`), g('/club-settings'),
      ]);
      setData({
        players: Array.isArray(players) ? players : [],
        teams: Array.isArray(teams) ? teams : [],
        matches: Array.isArray(matches) ? matches : [],
        tournaments: Array.isArray(tournaments) ? tournaments : [],
        categories: Array.isArray(categories) ? categories : [],
        clubInfo: clubInfo || null,
      });
      if (clubInfo?.club_name) setReportSettings((s) => ({ ...s, headerText: `${clubInfo.club_name} - التقرير` }));
      setLoading(false);
    })();
  }, [seasonId]);

  if (loading) {
    return <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">{[1, 2, 3, 4].map((i) => <div key={i} className="h-24 animate-pulse rounded-xl bg-slate-100" />)}</div>;
  }

  const finished = data.matches.filter((m) => m.status === 'finished' && m.home_score != null && m.away_score != null && m.home_team_is_club !== m.away_team_is_club);
  let wins = 0, draws = 0, losses = 0, goalsFor = 0, goalsAgainst = 0;
  finished.forEach((m) => {
    const forScore = m.home_team_is_club ? m.home_score : m.away_score;
    const againstScore = m.home_team_is_club ? m.away_score : m.home_score;
    goalsFor += forScore; goalsAgainst += againstScore;
    if (forScore > againstScore) wins += 1; else if (forScore === againstScore) draws += 1; else losses += 1;
  });
  const activePlayers = data.players.filter((p) => p.is_active);

  return (
    <div className="space-y-4" data-testid="sports-tab">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        <KpiCard icon="calendar" label="إجمالي المباريات" value={data.matches.length} testId="kpi-sports-matches" />
        <KpiCard icon="trophy" label="فوز / تعادل / خسارة" value={`${wins} / ${draws} / ${losses}`} testId="kpi-sports-record" />
        <KpiCard icon="arrowUp" label="أهداف له" value={goalsFor} accent="text-teal-700" testId="kpi-sports-gf" />
        <KpiCard icon="arrowDown" label="أهداف عليه" value={goalsAgainst} accent="text-red-600" testId="kpi-sports-ga" />
        <KpiCard icon="users" label="اللاعبون النشطون" value={activePlayers.length} testId="kpi-sports-players" />
      </div>

      <div data-testid="sports-advanced-reports">
        <UnifiedAdvancedReportsSection
          reportSettings={reportSettings}
          setReportSettings={setReportSettings}
          players={data.players}
          teams={data.teams}
          matches={data.matches}
          tournaments={data.tournaments}
          categories={data.categories}
          clubInfo={data.clubInfo}
          seasons={seasons}
          seasonId={seasonId}
          onSeasonChange={onSeasonChange}
        />
      </div>
    </div>
  );
}
